import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import { ARTICLES } from "@/data/articles";

/**
 * Subtle "Inzichten" cross-link block placed at the bottom of select
 * pages (Methode, Diensten). Visually calm, matches the SovEU style.
 */
export default function InzichtenLinkBlock({ title, intro, testid = "inzichten-link-block", excludeSlug }) {
  const items = excludeSlug ? ARTICLES.filter((a) => a.slug !== excludeSlug) : ARTICLES;
  return (
    <section className="section bg-white" data-testid={testid}>
      <div className="container-soveu max-w-3xl">
        <div className="border-t border-[#E5E9EF] pt-14">
          <FadeIn>
            <div className="eyebrow mb-3">Inzichten</div>
            <h2 className="h2-display mb-4">{title}</h2>
            <p className="text-[#334155] body-lg leading-relaxed mb-8">{intro}</p>
          </FadeIn>
          <div className="space-y-3">
            {items.map((a, i) => (
              <FadeIn key={a.slug} delay={i * 60}>
                <Link
                  to={a.to}
                  className="flex items-start justify-between gap-4 p-5 rounded-md border border-[#E5E9EF] hover:border-[#1E3A5F] transition-colors"
                  data-testid={`inzichten-cross-${a.slug}`}
                >
                  <div className="flex-1">
                    <div className="text-[12px] uppercase tracking-wide font-medium mb-1.5" style={{ color: "#6B7280" }}>
                      {a.category}
                    </div>
                    <div className="text-[16px] font-semibold leading-snug" style={{ color: "#1E3A5F" }}>
                      {a.title}
                    </div>
                  </div>
                  <ArrowRight size={18} className="flex-shrink-0 mt-1.5" style={{ color: "#2D6F8F" }} />
                </Link>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
